export enum TooltipModalTypes {
  ProfitAmount = 'ProfitAmount',
  ProfitPercentage = 'ProfitPercentage'
}
